import { SimpleModalComponent } from './../../simple-modal/simple-modal.component';
import { CardSdcComponent } from 'src/app/shared/card-sdc-despalha/sdc-card.component';
import { GeneralService } from 'src/app/services/general.service';
import { Component, OnInit, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { CardBarCodeComponent } from '../../card-barcode/card-barcode.component';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sdc-card-item',
    templateUrl: './sdc-card-item.component.html'
})


export class CardSdcItemComponent extends GeneralComponent implements OnInit, AfterViewInit {
    public formulario?: FormGroup;
    public disableBtn: boolean;
    public unique_key: number;
    public parentRef: CardSdcComponent;
    public readonlyCerar = false
    public btnExcluir = false

    // @ViewChild('txtCerar') txtCerar: ElementRef;

    // tslint:disable-next-line: max-line-length
    constructor(
        protected formularioService: FormularioService,
        protected formBuilder: FormBuilder,
        protected notificationService: NotificationService,
        protected generalService: GeneralService,
        public dialog: MatDialog) {
        super('', false);
        this.formulario = this.formBuilder.group({
            id: [null],
            cd_cerar: [null],
            cd_contrato: [null],
            qt_rw_kg: [null],
            qt_porcentagem_umidade_direcionamento: [null],
            qt_umidade_cerar: [null],
            qt_porcentagem_descarregado: [null, [Validators.max(100)]],
            qt_temperatura_maxima_do_tempo_total_de_transporte: [null],
            cd_lote_rw: [null],
            // qt_porcentagem_granacao: [null, []]
        });
    }
    
    @Output() mkCalc = new EventEmitter();

    ngAfterViewInit(): void {
        // this.txtCerar.nativeElement.focus();
    }

    public async ngOnInit(): Promise<void> {
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async openDialog(typeField: string): Promise<void> {
        await this.checkBtnLeitorDisable();
        const dialogRef = this.dialog.open(CardBarCodeComponent, {
            width: '670px',
            height: '700px',
            data: {
                field: typeField,
            },
        });
        dialogRef.afterClosed().subscribe(async data => {
            await this.checkBtnLeitorEnable();
            await this.resultAfterBarCode(typeField, data);
        });
    }

    private async resultAfterBarCode(field: string, barCode: string) {
        switch (field) {
            case 'Cerar':
                this.formulario.get('cd_cerar').setValue(barCode);
                break;
            case 'LoteRw':
                this.formulario.get('cd_lote_rw').setValue(barCode);
                break;
        }
    }

    public async getQua007Data(): Promise<void> {
        const cerar = this.formulario.get('cd_cerar')?.value as string;
        if (!!cerar) {
            await this.formularioService.getQua007Data(cerar).pipe(take(1)).toPromise().then((objQua007: any) => {
                this.formulario.get('cd_contrato').setValue(objQua007?.data?.contrato_juridico);
                this.formulario.get('qt_temperatura_maxima_do_tempo_total_de_transporte').setValue(objQua007?.data?.temperatura_maxima_tempo);
                let peso_liquido = objQua007?.data?.peso_liquido === '' ? null : objQua007?.data?.peso_liquido;
                this.formulario.get('qt_rw_kg').setValue(peso_liquido);
                this.formulario.get('cd_lote_rw').setValue(objQua007?.data?.lote_rw);

            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao cerar ${cerar}. Entre em contato com o Administrador.`);
            });
        }
    }

    public async getRs009Data(): Promise<void> {
        const cerar = this.formulario.get('cd_cerar')?.value as string;
        if (!!cerar) {
            await this.formularioService.getHumidityData(cerar).pipe(take(1)).toPromise().then((objRS009: any) => {
                this.formulario.get('qt_umidade_cerar').setValue(objRS009?.data);

            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao cerar ${cerar}. Entre em contato com o Administrador.`);
            });
        }
    }


    private async checkBtnLeitorDisable(): Promise<void> {
        this.disableBtn = true;
    }

    private async checkBtnLeitorEnable(): Promise<void> {
        this.disableBtn = false;
    }

    public async remove(lastIndex = false) {
        await Promise.all([this.parentRef.removeSdcDescargaItemComponent(this.unique_key, lastIndex), this.makeCalcSdc()])


    }


    delete = () => {
        let input = {
            title: 'Excluír Cerar',
            titleBtn1: 'Não',
            titleBtn2: 'Sim',
            mensage: `Deseja realmente excluír o Cerar: ${this.formulario.get('cd_cerar')?.value as string ?? ''} ?`,
        };

        const dialogRef = this.dialog.open(SimpleModalComponent, {
            width: '600px',
            data: input,
        });

        dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                this.remove()
            }
        });
    }
    public async makeCalcSdc(): Promise<void> {
        this.parentRef.calcSdc.emit();
    }
    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }
}

